import React from 'react';

// The editor's screens with no preview use Store settings' container: a page title with its
// description, in the centred content column.
// `narrow` keeps a short list to the width of an order page's main column.
export default function EditorSettingsScreen({
  title,
  description,
  actions,
  narrow = false,
  children,
}) {
  return (
    <div className="p-4 pb-16">
      <div className="mx-auto max-w-[80rem]">
        <div className={narrow ? 'max-w-2xl' : undefined}>
          <div className="mb-4">
            <div className="flex min-h-9 items-center justify-between gap-3">
              <h1 className="text-lg font-semibold text-gray-900 dark:text-foreground">{title}</h1>
              {actions}
            </div>
            {description && (
              <p className="text-sm text-gray-500 dark:text-muted-foreground">{description}</p>
            )}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
